import { MarketingCampaign, Practice } from '@principle-theorem/principle-core';
import {
  IPractice,
  MarketingCampaignType,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import {
  ALL_REGIONS,
  asReffable,
  CustomRecurrenceFrequency,
  DocumentReference,
} from '@principle-theorem/shared';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';

export function getBlankCampaignTemplate(
  practiceRef: DocumentReference<IPractice>
): IMarketingCampaignTemplate {
  return {
    name: 'Start from scratch',
    description: 'Create a campaign from scratch.',
    regions: ALL_REGIONS,
    campaign: MarketingCampaign.init({
      brandRef: Practice.brandRef(asReffable(practiceRef)),
      practiceRef,
      name: 'New Campaign',
      type: MarketingCampaignType.Marketing,
      scope: TemplateScope.Patient,
      entryResetRules: {
        multipleEntry: false,
        maxEntryCount: undefined,
        frequencyCount: 1,
        frequencyType: CustomRecurrenceFrequency.Daily,
      },
    }),
    steps: [],
  };
}
